import { AxiosInstance } from 'axios';

export type FundingDto = {
  personalCreditScore: number | null;
  businessStartMonth: number | null;
  businessStartYear: number | null;
  sumOfLoanCustomerNeeds: number | null;
};

export type FundingIntroductionRequestDto = {
  partnerName: string;
  partnerCode: string;
  funding: FundingDto;
};

export type FundingApi = ReturnType<typeof getFundingApi>;

export const getFundingApi = (axiosInstance: AxiosInstance) => {
  const getFunding = async (): Promise<FundingDto> =>
    axiosInstance.get<FundingDto>('/tenants/current/funding').then((r) => r.data);

  const updateFunding = async (request: FundingDto): Promise<FundingDto> =>
    axiosInstance.put<FundingDto>('/tenants/current/funding', request).then((r) => r.data);

  const requestIntroduction = async (request: FundingIntroductionRequestDto): Promise<void> =>
    axiosInstance
      .post<FundingDto>('/tenants/current/funding/partners/request-introduction', request)
      .then(() => {});

  return {
    getFunding,
    updateFunding,
    requestIntroduction,
  };
};
